import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import axios from "axios";
import api from "../../api/axiosInstance";
import $ from "jquery"; // Import jQuery (if it's not already available)

const FormMasterCard = ({
  title,
  sortedFormMasters,
  handleUpdateFormMasterStatus,
}) => {
  debugger;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useState(null);
  const [formMaster, setFormMaster] = useState(null);

  // Open Modal & Fetch Job Categories
  const openModal = async () => {
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  useEffect(() => {
    InitializeTables(); // Call InitializeTables to initialize all tables

    console.log("form :" + form);
    console.log("formMaster :" + formMaster);
  }, []); // Re-run when the sortedFormMasters data changes
  const InitializeTables = () => {
    if (!$.fn.DataTable) {
      console.error("DataTables is not loaded.");
      return;
    }

    const selector = ".data-table";
    if ($.fn.DataTable.isDataTable(selector)) {
      $(selector).DataTable().clear().destroy();
    }

    $(selector).DataTable({
      responsive: true,
      autoWidth: false,
      searching: false,
      ordering: true,
      pageLength: 10,
      lengthChange: false,
      paging: false,
      info: false,
    });
  };

  const HandleStatusUpdate = (formId, status) => {
    debugger;
    if (!formId) {
      $.alert("form Id is required");
      return;
    }

    handleUpdateFormMasterStatus(formId, status); // Correctly invoke the function
  };

  const OnClickView = (id) => {
    debugger;
   api
      .get(`/FormMaster/ViewFormMaster/${id}`)
      .then((response) => {
        debugger;
        const formMaster = response.data.formMaster;
        const formMasterJobCategories = response.data.formMasterJobCategories;
        debugger;
        // formMaster = formMaster;
        // Extract settings and format
        setForm({
         allowSubmitterToSelectRecipient: formMaster.allowSubmitterToSelectRecipient
,
        });
        
        const settings = Object.keys(formMaster)
          .filter((key) => key.startsWith("allow"))
          .map((key) => {
            let label = key.replace(/([A-Z])/g, " $1").trim(); // Add spaces between camelCase words
            label = label.charAt(0).toUpperCase() + label.slice(1); // Capitalize the first letter

            let status = formMaster[key] ? "<b>Enabled</b>" : "<b>Disabled</b>"; // Make Enabled/Disabled bold
            return `${label}: ${status}`;
          })
          .join("<br>"); // Use <br> for new lines
        // Update state
        setForm({
          availableFor: formMasterJobCategories, // Placeholder, update as needed
       recipientJobCategoryName :formMaster.recipientJobCategoryName,
          recipients: formMaster.recipientContactName || "N/A",

          settings: settings,
        });
        debugger;
    console.log("jobCategory", formMaster.rec)
        //  console.log("DIL bhai :"+form.allowSubmitterToSelectRecipient);
        //  console.log("SummarySettings :"+ form.summarySetting);
        openModal();
      })
      .catch((error) => console.error("Error fetching form data", error));
  };
  const handlePreviewClick = (id) => {
    debugger;
    console.log("clicked");
    var recordGuidStr = id;
    const userData = JSON.parse(localStorage.getItem("user")); // Get user info from localStorage
    const loggedinUserid = userData ? userData.email : null; // Get logged-in user email
    if (loggedinUserid) {
      // Navigate to FormPreviewPage with the email and recordGuidStr as query parameters
      // navigate(`/editor/form-preview?recordGuidStr=${recordGuidStr}`);
      const previewUrl = `/editor/form-preview?recordGuidStr=${recordGuidStr}`;
      window.open(previewUrl, "_blank");

      // Page?recordGuidStr=${recordGuidStr}&loggedinUserid=${loggedinUserid}
    } else {
      console.error("User is not logged in or email is missing");
    }
  };

  // const formatSettings = (settingsObj) => {
  //   if (!settingsObj) return "N/A";

  //   return Object.entries(settingsObj)
  //     .map(([key, value]) => `${key}: ${value}`)
  //     .join("\n");  // Adds a new line after each setting
  // };
  return (
    <>
      <div className="card card-success" style={{ marginTop: "5px" }}>
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
        </div>
        <div className="card-body">
          <table
            id="example1"
            className="table table-bordered table-striped data-table"
          >
            <thead>
              <tr>
                <th width="22%">Name</th>
                <th width="23%">Category</th>
                <th width="20%">Sub-Category</th>
                <th width="10%">Created On</th>
                <th width="10%">Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedFormMasters.length === 0 ||
              sortedFormMasters.length === undefined ||
              sortedFormMasters.length === null ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              ) : (
                sortedFormMasters.map((formMaster) => (
                  <tr key={formMaster.id}>
                    <td>{formMaster.name}</td>
                    <td>{formMaster.formCategoryName}</td>
                    <td>{formMaster.formSubCategoryName}</td>
                    <td>
                      {new Date(formMaster.createdOn).toLocaleDateString()}
                    </td>
                    <td>
                      {title === "Approved Forms" && (
                        <>
                          <button
                            onClick={() => handlePreviewClick(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#17a2b8",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Preview Form"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                          &nbsp;
                          <button
                            onClick={() => OnClickView(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Form Settings"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                        </>
                      )}
                      &nbsp;
                      {title === "Rejected Forms" && (
                        <>
                          <button
                            onClick={() => handlePreviewClick(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#17a2b8",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Preview Form"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                          &nbsp;
                          <button
                            onClick={() => OnClickView(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Form Settings"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                        </>
                      )}
                      {/* Commented out CRUD operation buttons */}
                      {/* <button className="btn btn-xs btn-danger"
                    onClick={() => {
                      $.confirm({
                        title: 'Confirm Deletion',
                        content: 'Do you really want to delete this?',
                        type: 'red',
                        buttons: {
                          confirm: {
                            text: 'Yes',
                            btnClass: 'btn-red',
                            action: function () {
                              handleDelete(formMaster.id); // Call handleDelete from parent
                            }
                          },
                          cancel: {
                            text: 'No',
                            btnClass: 'btn-default',
                          }
                        }
                      });
                    }}
                    title="Delete">
                    <i className="fa fa-trash"></i>
                  </button> */}
                      {/* <button className="btn btn-xs btn-primary" title="Approve"
                    onClick={() => handleApprove(formMaster.id)}>
                    <i className="fa fa-check"></i>
                  </button> */}
                      {/* <button className="btn btn-xs btn-warning" title="Reject"
                    onClick={() => handleReject(formMaster.id)}>
                    <i className="fa fa-times"></i>
                  </button> */}
                      {/* <button className="btn btn-xs btn-success" title="Activate"
                    onClick={() => handleActivate(formMaster.id)}>
                    <i className="fa fa-check-circle"></i>

                  </button> */}
                      {/* {title === 'Waiting For Approval Forms' && (
                        
                       <Link to={`/editor/FormMastersView/${formMaster.id}`} className="btn btn-xs btn-success" title="View">
                        <i className="fa fa-eye"></i>
                      </Link>
                      )} */}
                      {/* Button to open modal */}
                      {title === "Waiting For Approval Forms" && (
                        <>
                          <button
                            onClick={() => handlePreviewClick(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#17a2b8",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Preview Form"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                          &nbsp;
                          <button
                            onClick={() => OnClickView(formMaster.id)}
                            style={{
                              padding: "5px 7px",
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "10px",
                              cursor: "pointer",
                              transition: "background 0.3s ease",
                              marginBottom: "0px",
                            }}
                            title="Form Settings"
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                        </>
                      )}
                      &nbsp;
                      {title === "Waiting For Approval Forms" && (
                        <button
                          type="button"
                          className="btn btn-success btn-xs btn-primary"
                          title="Approve"
                          data-toggle="modal"
                          data-target="#modal-sm"
                          onClick={() =>
                            HandleStatusUpdate(formMaster.id, 121440001)
                          }
                        >
                          <i className="fa fa-check"></i>
                        </button>
                      )}
                      &nbsp;
                      {title === "Waiting For Approval Forms" && (
                        <button
                          type="button"
                          className="btn btn-danger btn-xs btn-primary"
                          title="Reject"
                          data-toggle="modal"
                          data-target="#modal-sm"
                          onClick={() =>
                            HandleStatusUpdate(formMaster.id, 121440002)
                          }
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Popup */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Set Recipients"
        style={modalStyles}
      >
        <h2 style={styles.header}>Form Details:-</h2>

        {form ? (
          <>
            {/* Available For */}
            {/* <div style={styles.fieldContainer}> */}

            <h2 style={styles.header}>Available for:</h2>
            <div style={{ textAlign: "center" }}>
              <label style={{ textAlign: "center" }}>
                {form?.availableFor
                  ?.map((jobCatgory) => jobCatgory.jobCategoryName)
                  .join(", ") || "N/A"}
              </label>
            </div>
            {/* </div> */}
            {/* <br></br> */}
            <div style={{ textAlign: "center" }}>
              <label style={styles.header}>Will be submitted to :</label>
            </div>
            {/* Container for 4 columns */}
            <div style={styles.formContainer}>
              {/* Available For */}
              <div style={styles.fieldContainer}>
                <label style={styles.label}>Job Category:</label>
                <input
                  type="text"
                  value={form.recipientJobCategoryName || "N/A"}
                  readOnly
                  style={styles.input}
                />
              </div>

              {/* Recipients */}
              <div style={styles.fieldContainer}>
                <label style={styles.label}>User:</label>
                <input
                  type="text"
                  value={form.recipientContactName || "All"}
                  readOnly
                  style={styles.input}
                />
              </div>
            </div>

            {/* Settings Label in a Separate Row */}
            <div style={styles.row}>
              <label style={styles.label}>Settings:</label>
            </div>

            {/* Textarea in a New Row */}

            {/* Render settings with bold Enabled/Disabled text */}
            <div
              style={styles.textarea}
              dangerouslySetInnerHTML={{ __html: form?.settings || "N/A" }}
            />

            {/* Buttons */}
            <div style={styles.buttonContainer}>
              <button onClick={closeModal} style={styles.cancelButton}>
                Close
              </button>
              {/* <button style={styles.saveButton}>Save</button> */}
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <h3>Loading form details...</h3>
          </div>
        )}
      </Modal>
    </>
  );
};

const styles = {
  header: {
    textAlign: "center",
    marginBottom: "15px",
    fontSize: "20px",
    fontWeight: "bold",
  },
  formContainer: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap", // Allows responsiveness
    justifyContent: "space-between",
  },
  fieldContainer: {
    flex: "1 1 22%", // Makes each field 22% wide to fit 4 in one row
    minWidth: "180px",
  },
  label: {
    fontWeight: "bold",
    display: "block",
    marginBottom: "5px",
  },
  input: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  cancelButton: {
    padding: "10px 15px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  saveButton: {
    padding: "10px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  row: {
    width: "100%",
    display: "block",
    marginBottom: "8px", // Adds spacing between rows
  },
  label: {
    fontWeight: "bold",
    fontSize: "16px",
    display: "block", // Ensures the label is on a separate line
    marginBottom: "5px",
  },
  textarea: {
    width: "100%",
    height: "fit-content",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    resize: "none",
    boxSizing: "border-box",
  },
};

// Modal Styles
const modalStyles = {
  overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  content: {
    width: "50%",
    margin: "auto",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
};

export default FormMasterCard;
